import {
    signApprovedFile,
    signIssuedFile,
    signIncomingFile,
    signListFiles,
} from "@app/pages/kySo/helperKyToken";
import React, { useState } from "react";

import { toast } from "react-toastify";

const DigitalSign = () => {
    const [fileUrl, setFileUrl] = useState("");
    const [result, setResult] = useState(null);

    const handleSignApproved = async () => {
        try {
            const res = await signApprovedFile(fileUrl);
            setResult(res);
            toast.success("Ký phê duyệt thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignIssued = async () => {
        try {
            const res = await signIssuedFile(fileUrl, "79", "");
            setResult(res);
            toast.success("Ký phát hành thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignIncome = async () => {
        try {
            const res = await signIncomingFile(fileUrl, [
                { Key: "LoaiVanBan", Value: "CongVanDen" },
            ]);
            setResult(res);
            toast.success("Ký công văn đến thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    const handleSignManyFiles = async () => {
        try {
            const res = await signListFiles([
                {
                    FileID: "1",
                    FileName: "test1.pdf",
                    URL: fileUrl,
                },
            ]);
            setResult(res);
            toast.success("Ký danh sách file thành công");
        } catch (err) {
            console.error(err);
            toast.error(err?.Message || err?.message || "Ký số thất bại");
        }
    };

    return (
        <div className="container mt-4">
            <h3>Ký số VGCA + OpenIddict SSO</h3>

            <input
                className="form-control"
                placeholder="Nhập URL file PDF cần ký"
                value={fileUrl}
                onChange={(e) => setFileUrl(e.target.value)}
            />

            <div className="mt-3">
                <button className="btn btn-primary mr-2" onClick={handleSignApproved}>
                    Lãnh đạo ký phê duyệt
                </button>

                <button className="btn btn-success mr-2" onClick={handleSignIssued}>
                    Văn thư ký phát hành
                </button>

                <button className="btn btn-warning mr-2" onClick={handleSignIncome}>
                    Ký công văn đến
                </button>

                <button className="btn btn-info" onClick={handleSignManyFiles}>
                    Ký danh sách file
                </button>
            </div>

            {result && (
                <pre className="mt-3 bg-light p-3">
                    {JSON.stringify(result, null, 2)}
                </pre>
            )}
        </div>
    );
};

export default DigitalSign;